import antdAr from "antd/locale/ar_EG";
import saMessages from "../locales/ar_SA.json";

const saLang = {
  messages: {
    ...saMessages
  },
  antd: antdAr,
  locale: 'ar'
};
export default saLang;
